export const AUTH_FLOW_INPUT_CLASSNAME =
  "transition-colors duration-200 focus-visible:ring-brand-alt";
